export enum MissionState {
  Send = 'SEND',
  Waiting = 'INIT'
}
